export const PHONE_REQUIRED_LENGTH = 11;

export const EMPTY_ANSWER_ERROR = 'Пожалуйста, выберите один из вариантов';
export const PHONE_LENGTH_ERROR = 'Пожалуйста, введите корректный номер телефона';
export const INCORRECT_PHONE_ERROR = 'Пожалуйста, введите корректный номер телефона';
export const EMPTY_PHONE_ERROR = 'Необходимо указать номер телефона';
export const AGREEMENT_ERROR = 'Для продолжения подтвердите свое согласие с Политикой конфиденциальности';
export const CLOSE_WITH_ERROR = 'get_error'
export const GET_ECOMMERCE_ACTION = 'get_ecommerce_action';

export const AB_TEST_CALL_TIME = 'call_time';
export const AB_TEST_FORM_HEADER_TEXT = 'form_header_text';
export const AB_TEST_FORM_BUTTON_TEXT = 'form_button_text';
export const AB_TEST_FORM_FIELDS_STRUCT = 'form_fields_struct';
export const AB_TEST_FORM_VISUAL = 'phone_form_visual';
export const AB_TEST_BONUSES = 'bonuses';
export const AB_TEST_COMMON_SERVICE_LIST = 'commmon-service-list';
export const AB_TEST_PHONE_PLACEHOLDER = 'phone-placeholder';
